import React from 'react';

const CalendarControls = ({ 
  currentDate, 
  view, 
  filters, 
  onMonthChange, 
  onViewChange, 
  onFiltersChange, 
  onAddAppointment,
  mockData 
}) => {
  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const practitionerOptions = mockData?.practitioners?.map(p => ({
    value: p.id,
    label: p.name
  })) || [];

  const locationOptions = mockData?.locations?.map(l => ({
    value: l.id,
    label: l.name
  })) || [
    { value: 'harley-street', label: 'Harley Street' },
    { value: 'canary-wharf', label: 'Canary Wharf' },
    { value: 'kensington', label: 'Kensington' }
  ];

  const handlePractitionerChange = (e) => {
    onFiltersChange({
      ...filters,
      practitioner: e.target.value
    });
  };

  const handleLocationChange = (e) => {
    onFiltersChange({
      ...filters,
      location: e.target.value
    });
  };

  return (
    <div className="calendar-controls">
      <div className="calendar-nav-container">
        <button 
          className="calendar-nav-btn" 
          onClick={() => onMonthChange(-1)}
        >
          ‹ Previous
        </button>
        <div className="calendar-month-year">
          {monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}
        </div>
        <button 
          className="calendar-nav-btn" 
          onClick={() => onMonthChange(1)}
        >
          Next ›
        </button>
      </div>
      
      <div className="calendar-filters">
        <select 
          className="form-input" 
          value={filters.practitioner}
          onChange={handlePractitionerChange}
          style={{ width: 'auto' }}
        >
          <option value="">All Practitioners</option>
          {practitionerOptions.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        
        <select 
          className="form-input" 
          value={filters.location}
          onChange={handleLocationChange}
          style={{ width: 'auto' }}
        >
          <option value="">All Locations</option>
          {locationOptions.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        
        <div className="calendar-view-toggle">
          <button 
            className={`view-toggle-btn ${view === 'month' ? 'active' : ''}`}
            onClick={() => onViewChange('month')}
          >
            Month
          </button>
          <button 
            className={`view-toggle-btn ${view === 'week' ? 'active' : ''}`}
            onClick={() => onViewChange('week')}
          >
            Week
          </button>
          <button 
            className={`view-toggle-btn ${view === 'day' ? 'active' : ''}`}
            onClick={() => onViewChange('day')}
          >
            Day
          </button>
        </div>
        
        <button 
          className="btn btn-primary"
          onClick={onAddAppointment}
        >
          + New Appointment
        </button>
      </div>
    </div>
  );
};

export default CalendarControls;
